<template>
	<div id="app">
		<keep-alive><router-view v-if="$route.meta.keepAlive"/></keep-alive>
		 <router-view v-if="!$route.meta.keepAlive"/>
		<dialogLogin v-if="this.$store.state.dialogShow"></dialogLogin>
		<consultation v-if="this.$store.state.chatShow"></consultation>
		<editPwd v-if="$store.state.editPwd>0" />
	</div>
</template>
<script>
import dialogLogin from "@/components/dialogLogin";
import consultation from "@/components/consultation";
import editPwd from "@/components/editPwd";
export default {
	name: "App",
	components: {
		dialogLogin,
		consultation,
		editPwd,
	},
	mounted() {
		(function () {
			// 得到手机屏幕的宽度
			let htmlWidth =
				document.documentElement.clientWidth || document.body.clientWidth;
			console.log("htmlWidth：", htmlWidth);
			if (htmlWidth > 1920) {
				htmlWidth = 1920;
			}
			// 得到html的Dom元素
			let htmlDom = document.getElementsByTagName("html")[0];
			// 设置根元素字体大小
			htmlDom.style.fontSize = (htmlWidth / 1920) * 100 + "px";
		})()
		
		if (!this.$store.getters.editPwd && sessionStorage.getItem('editPwd')) {
			this.$store.dispatch('getEditPwd', sessionStorage.getItem('editPwd'))
		}
	},
	methods: {},
};
</script>
<style lang="less">
@import url("../static/style/index.less");
* {
  padding: 0;
  margin: 0;
    
}
.el-message{
    font-size: 24px !important;
}

html,
body,
#app,
.wrap {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  // overflow: hidden;
   background: #F3F9FF !important;
}
.rightbtn {
  position: fixed;
  right: 0.4rem;
  top: 30%;
  background: #fff;
  li {
    font-size: 0.2rem;
  }
}
.v-modal{
	display: none;
}
</style>


// WEBPACK FOOTER //
// src/App.vue